"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _pipelineEpics = _interopRequireDefault(require("./pipelineEpics"));

var _quotaEpics = _interopRequireDefault(require("./quotaEpics"));

var _hubUsersEpics = require("./hubUsersEpics");

var _default = (0, _reduxObservable.combineEpics)(_quotaEpics.default, _pipelineEpics.default, _hubUsersEpics.hubUsersEpic);

exports.default = _default;
module.exports = exports.default;